export default "__VITE_ASSET__ZpG1IFa3__"